import { useEffect, useState } from "react";
import { loadGameData } from "@/data/loader";
import { useGameStore } from "@/store/gameStore";
import { useUiStore } from "@/store/uiStore";
import Board from "@/components/Board";
import HeroSelect from "@/components/HeroSelect";
import FxLayer from "@/hooks/useEventFx";
import "@/styles/effects.css";

export default function App() {
  const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");
  const [error, setError] = useState("");
  const load = useGameStore((s) => s.load);
  const appPhase = useGameStore((s) => s.appPhase);
  const setView = useUiStore((s) => s.setView);

  // 视口监听
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const apply = () => setView(mq.matches ? "mobile" : "desktop");
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [setView]);

  // 数据加载
  useEffect(() => {
    loadGameData()
      .then((d) => {
        load(d);
        setStatus("ready");
      })
      .catch((e) => {
        setError(String(e));
        setStatus("error");
      });
  }, [load]);

  if (status === "loading") return <div style={{ padding: 24, color: "var(--dim)" }}>加载中...</div>;
  if (status === "error") return <div style={{ padding: 24, color: "var(--red)" }}>加载失败：{error}</div>;

  if (appPhase === "select") return <HeroSelect />;

  return (
    <>
      <FxLayer />
      <Board />
    </>
  );
}
